export const FEEDBACK_ACTION = 'FEEDBACK_ACTION';
export const FEEDBACK_SUCCESS_ACTION = 'FEEDBACK_SUCCESS_ACTION';
export const FEEDBACK_FAILURE_ACTION = 'FEEDBACK_FAILURE_ACTION';
